var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Especialidades","storeName":"Specialities","parentStoreName":"Jobs","parentUrlKey":"job_id","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"canSearch":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }